import React, { useEffect, useState } from 'react';

import { sendGtEvent } from 'analytics/analytics';
import { sendBrazeEvent } from 'analytics/braze';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import { getRecipientTypeParam, providerCategories } from 'components/utils/AmplitudeUtils';

import { TRANSFER_CONFIRMATION_SHOWN } from 'constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYMENT_FLOW,
    PAYMENT_METHOD_AMPLITUDE,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    RECIPIENT_TYPE,
    TRANSFER_ID,
} from 'constants/amplitude/AmplitudeParamName';
import { BR_SEND_SUCCESS } from 'constants/braze/brazeEvents';
import {
    BR_AMOUNT_SEND_CURRENCY,
    BR_PAYSEND_ID,
    BR_RECEIVING_COUNTRY_CODE,
    BR_SEND_CURRENCY,
    BR_SENDING_COUNTRY_CODE,
    BR_TRX_ID,
} from 'constants/braze/brazeParams';
import {
    CATEGORY_TRANSFER_TO_CASH,
    CATEGORY_TRANSFER_TO_HOME_DELIVERY,
    CATEGORY_TRANSFER_TO_INTERAC,
    CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC,
} from 'constants/Constants';
import { GT_SEND_SUCCESS } from 'constants/GoogleAnalyticsEvents';
import { GT_AMOUNT_SEND_CURRENCY, GT_SEND_CURRENCY, GT_TRX_ID, GT_USER_ID } from 'constants/GoogleAnalyticsParamNames';
import { AUTH_MY_CARDS_URL, AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'constants/UrlConstants';

import { timer } from 'helpers/utils';

import amplitude from 'amplitude-js';
import { useAuth, useExtra, usePageMessages } from 'hooks/selectors';

import { REACHING_LIMIT_SCREEN, UPGRADE_LIMIT_SCREEN, WAITING_SCREEN } from './Constants';
import PromoReachingLimit from './PromoReachingLimit';
import PromoUpgradeLimit from './PromoUpgradeLimit';
import { DangerouslyHtml } from '../../common/DangerouslyHtml/DangerouslyHtml';

const Waiting = (props) => {
    let timerID = null;
    const { cardPan, cheque, statusBean } = useExtra();
    const { ballId } = useAuth();
    const { headerTitle, statusText, statusDoneTitle, cancelTransaction30Minutes } = usePageMessages();
    const [screen, setScreen] = useState(WAITING_SCREEN);
    const fromCategory = cheque?.providerFromCategory.toString();
    const toCategory = cheque?.providerToCategory.toString();
    const sendingMethod = providerCategories[fromCategory];
    const deliveryMethod = providerCategories[toCategory];
    const toCountry = cheque?.toCountry?.nameEn;
    const fromCountry = cheque?.fromCountry?.nameEn;

    const isDeliveryOnCashOrInteract = () => {
        return (
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_CASH ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC
        );
    };

    useEffect(() => {
        if (isDeliveryOnCashOrInteract()) {
            timerID = timer(
                timerID,
                () => {
                    window.location.href = AUTH_SEND_MAIN_LINK;
                },
                400,
            );
        } else if (!props.smsOnSuccessPay && props.status) {
            timerID = timer(
                timerID,
                () => {
                    location.reload();
                },
                400,
            );
        }
        return () => clearTimeout(timerID);
    }, []);

    useEffect(() => {
        const paymentParam = sessionStorage?.getItem(cheque?.paymentId);
        amplitude.getInstance().logEvent(TRANSFER_CONFIRMATION_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry,
            [PAYMENT_COUNTRY]: fromCountry,
            [PAYOUT_CURRENCY]: cheque?.amountToCurrency,
            [PAYMENT_CURRENCY]: cheque?.amountFromCurrency,
            [PAYOUT_METHOD]: deliveryMethod,
            [PAYMENT_METHOD_AMPLITUDE]: sendingMethod,
            // [PAYOUT_METHOD_CATEGORY]: '',
            // [PAYMENT_METHOD_CATEGORY]: '',
            [TRANSFER_ID]: cheque?.paymentId,
            [PAYMENT_FLOW]: paymentParam,
            [RECIPIENT_TYPE]: getRecipientTypeParam(statusBean?.recipientType),
        });
        sendGtEvent(GT_SEND_SUCCESS, {
            [GT_USER_ID]: ballId,
            [GT_TRX_ID]: cheque?.paymentId,
            [GT_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [GT_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
        });
        sendBrazeEvent(BR_SEND_SUCCESS, {
            [BR_TRX_ID]: cheque?.paymentId,
            [BR_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [BR_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
            [BR_PAYSEND_ID]: ballId,
            [BR_SENDING_COUNTRY_CODE]: cheque?.fromCountryId,
            [BR_RECEIVING_COUNTRY_CODE]: cheque?.toCountryId,
        });
    }, []);

    const getPrimaryButtonLink = () => {
        if (props.status?.showUpgradeLimitPromo) {
            return '#';
        } else if (cardPan) {
            return AUTH_MY_CARDS_URL;
        } else if (props.status?.showInviteCodeReferralButton) {
            return AUTH_PROFILE_INVITE + '?showPromoSliders=true';
        } else {
            return AUTH_SEND_MAIN_LINK;
        }
    };
    const primaryButtonOnClick = (e) => {
        if (props.status?.showUpgradeLimitPromo) {
            e.preventDefault();
            setScreen(REACHING_LIMIT_SCREEN);
        }
        sessionStorage?.removeItem(cheque?.paymentId);
    };
    const renderScreen = (currentScreen) => {
        switch (currentScreen) {
            case REACHING_LIMIT_SCREEN:
                return <PromoReachingLimit primaryButtonOnClick={() => setScreen(UPGRADE_LIMIT_SCREEN)} />;
            case UPGRADE_LIMIT_SCREEN:
                return <PromoUpgradeLimit />;
            default:
                return (
                    <InfoPage
                        animatedIconSuccess
                        headerText={headerTitle}
                        secondaryText={statusBean?.canCancelTransaction ? cancelTransaction30Minutes : <DangerouslyHtml dangerouslyHtml={statusText} />}
                        primaryButtonCaption={!isDeliveryOnCashOrInteract() ? statusDoneTitle : null}
                        primaryButtonType="link"
                        primaryButtonLink={getPrimaryButtonLink()}
                        primaryButtonOnClick={primaryButtonOnClick}
                    />
                );
        }
    };
    return renderScreen(screen);
};

export default Waiting;
